import { FC, SVGProps } from 'react';

const LinkIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.31149 11.5877C9.66388 13.3957 12.226 13.7655 14.034 12.4131C14.1905 12.2955 14.3389 12.1674 14.4767 12.0296L16.3521 10.1542C17.921 8.53025 17.8755 5.94217 16.2515 4.3733C14.6673 2.84334 12.1555 2.84334 10.5704 4.3733"
        stroke="#009DE2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6884 8.41416C10.3361 6.60611 7.77395 6.23638 5.96589 7.58878C5.8094 7.70635 5.66104 7.83445 5.5232 7.97228L3.64785 9.84766C2.07896 11.4717 2.12437 14.0597 3.74838 15.6286C5.33266 17.1593 7.84449 17.1593 9.42957 15.6286"
        stroke="#009DE2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkIcon;
